<template>
  <div class="system-condition" v-loading="loadingProject" element-loading-text="加载中...">
    <!-- 系统切换tabs -->
    <el-tabs v-model="activeSystem" @tab-click="handleSystemChange" class="system-tabs">
      <el-tab-pane v-for="system in systemList" :key="system.value" :label="system.label" :name="system.value">
      </el-tab-pane>
    </el-tabs>

    <!-- 项目状态卡片 -->
    <el-card class="status-card" v-loading="projectLoading">
      <div slot="header" class="clearfix">
        <span class="card-title">项目活跃度 (活跃项目占比：{{ projectLivenessRatio }})</span>
      </div>
      <w-table ref="wMyTable" :columns="bzStatisticsByProjectStatusColumns" :table-data="projectData"
        :isPagination="true" :page="projectPage" @getTableSearchSortCon="getProjectTableSearchSortCon"
        @pageChange="handleProjectPagePagination">
        <template slot="projectId" slot-scope="{text,record}">
          <a @click="goToProjectDetail(record.projectId)">
            {{ record.projectId }}
          </a>
        </template>
        <template slot="vitality" slot-scope="{text, record}">
          <el-tag :type="record.vitality === 1 ? 'success' : 'danger'">
            {{ record.vitality === 1 ? '活跃' : '非活跃' }}
          </el-tag>
        </template>
        <template slot="customerName" slot-scope="{text, record}">
          <div>
            {{ record.customerName.join('; ') }}
          </div>
        </template>
        <template slot="salesName" slot-scope="{text, record}">
          <div>
            {{ record.salesName.join('; ') }}
          </div>
        </template>
        <!-- 
        <template slot="salesNames" slot-scope="{text,record}">
          <el-tag v-for="name in record.salesNames" :key="name" style="margin-right: 5px">
              {{ name }}
            </el-tag>
        </template>
        <template slot="customers" slot-scope="{text,record}">
          <el-tag v-for="customer in record.customers" :key="customer" style="margin-right: 5px">
              {{ customer }}
            </el-tag>
        </template>
        <template slot="AnalyzeNumber" slot-scope="{text,record}">
          {{ getAnalysisCount(record.projectId) }}
        </template>
        <template slot="CustomerCreatedAnalyzeNumber" slot-scope="{text,record}">
          {{ getClientAnalysisCount(record.projectId) }}
        </template> -->
      </w-table>
    </el-card>
    
    <!-- 用户统计卡片 -->
    <el-card class="user-stats-card" v-loading="userLoading">
      <div slot="header" class="clearfix">
        <span class="card-title">用户活跃度 (活跃用户占比：{{ livenessRatio }})</span>
      </div>
      <w-table ref="wMyTable" :columns="StatisticsByUserItemsColumns" :table-data="customerData" :isPagination="true"
        :page="customerPage" @getTableSearchSortCon="getCustomerTableSearchSortCon"
        @pageChange="handleCustomerPagePagination">
        <template slot="vitality" slot-scope="{text, record}">
          <el-tag :type="record.vitality === 1 ? 'success' : 'danger'">
            {{ record.vitality === 1 ? '活跃' : '非活跃' }}
          </el-tag>
        </template>
        <template slot="unLivenessProjectIds" slot-scope="{text, record}">
          <div>
            <span v-for="(projectId, index) in record.unLivenessProjectIds" :key="projectId">
              <a @click="goToProjectDetail(projectId)">{{ projectId }}</a>
              <span v-if="index < record.unLivenessProjectIds.length - 1">, </span>
            </span>
          </div>
        </template>
        <!-- <template slot="whetherActiveOrNot" slot-scope="{text,record}">
          <el-tag :type="record.inactiveCount > 0 ? 'danger' : 'success'">
            {{ record.inactiveCount > 0 ? '否' : '是' }}
          </el-tag>
        </template>
        <template slot="inactiveProjects" slot-scope="{text,record}">
            <div v-for="projectId in record.inactiveProjects" :key="projectId" class="project-id-container">
              <el-tag type="info" style="margin-right: 5px" @click="goToProjectDetail(projectId)">
                {{ projectId }}
              </el-tag>
              <el-button type="text" icon="el-icon-document-copy" @click="copyProjectId(projectId)">
              </el-button>
            </div>
          </template> -->
      </w-table>
    </el-card>
  </div>
</template>


<script>
import { getDataInLocalStorage } from "@/utils/localStorage";
import { projectLivenessPage, customerLivenessPage } from "@/api/bz";
import { projectLivenessPage_trans, customerLivenessPage_trans } from "@/api/trans";
import { projectLivenessPage_metag, customerLivenessPage_metag } from "@/api/metag";
import { projectLivenessPage_metabo, customerLivenessPage_metabo } from "@/api/metabo";
import { StatisticsByUserItemsColumnsData } from "@/utils/data/tableCol/bzStatisticsByUserItemsTableCol";
import { bzStatisticsByProjectStatusColumnsData } from "@/utils/data/tableCol/bzStatisticsByProjectStatusDataTableCol";
import * as echarts from 'echarts';

export default {
  data() {
    return {
      user: '',
      projectPage: {
        pageSize: 10,
        currentNum: 1,
        total: 0
      },
      customerPage: {
        pageSize: 10,
        currentNum: 1,
        total: 0
      },
      projectData: [],
      customerData: [],
      analysisData: {},
      loadingProject: false,
      projectLoading: false,
      userLoading: false,
      personUuids: '',
      filteredProjects: [],
      userStats: [],
      salesList: [], // 销售列表
      allSalesData: {}, // 存储所有销售的数据
      // 新增系统相关数据
      activeSystem: 'bz', // 当前选中的系统
      systemList: [
        { label: '多样性交付系统', value: 'bz' },
        { label: '转录组交付系统', value: 'trans' },
        { label: '宏基因组交付系统', value: 'metag' },
        { label: '代谢组交付系统', value: 'metabo' },
      ],
      projectSearchConditionTag: [],
      customerSearchConditionTag: [],
      livenessRatio: '0',
      projectLivenessRatio: '0'
    }
  },
  mounted() {
    this.user = JSON.parse(getDataInLocalStorage('user'))
    this.getProjectData()
    this.getCustomerData()
  },
  computed: {
    StatisticsByUserItemsColumns() {
      let column = JSON.parse(JSON.stringify(StatisticsByUserItemsColumnsData(this.customerSearchConditionTag || {})))
      if (['ANALYST', 'TECH'].includes(this.$store.getters["right/getRole"])) {
        column.splice(column.length - 1, 1)
      } else {
        if (this.$store.getters["right/getRole"] === 'USER') {
          column.splice(column.length - 4, 1)
        }
      }

      return column
    },
    bzStatisticsByProjectStatusColumns() {
      let column = JSON.parse(JSON.stringify(bzStatisticsByProjectStatusColumnsData(this.projectSearchConditionTag || {})))
      console.log("column=",column);
      
      if (['ANALYST', 'TECH'].includes(this.$store.getters["right/getRole"])) {
        column.splice(column.length - 1, 1)
      } else {
        if (this.$store.getters["right/getRole"] === 'USER') {
          column.splice(column.length - 4, 1)
        }
      }

      return column
    }
  },
  methods: {
    //获取tag的搜索排序的内容
    getCustomerTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.customerSearchConditionTag = searchConditionTag
      // this.sortConditionTag = sortConditionTag
      this.getCustomerData('search')
    },
    getProjectTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.projectSearchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getProjectData('search')
    },
    //获取项目列表
    async getProjectData(type) {
      this.projectLoading = true
      var sendData = {
        page: {
          current: this.projectPage.currentNum,
          size: this.projectPage.pageSize,
        }
      }
      if(type){
        sendData.page.current=1
        sendData.page.size=10
      }
      let length = this.projectSearchConditionTag.length
      if (length) {
        sendData.condition = {}
        this.projectSearchConditionTag.forEach(item => {
          let key = item.key
          if (key === 'createTime') {
            let value = item.value
            let index = value.indexOf('至')
            let value1 = value.substring(0, index)
            let value2 = value.substring(index + 1, value.length)
            sendData.condition.createTime = [addT(value1), addT(value2)]
          } else if (key === 'rawDataStatus') {
            sendData.condition.rawDataStatus = getRawDataStatusEnByCh(item.value)
          }  else {
            sendData.condition[key] = item.value
          }
        })
      } else {
        sendData.condition = {}
      }
      sendData.sorts = this.sortConditionTag

      let res
      if (this.activeSystem === 'bz') {
        res = await projectLivenessPage(sendData);
      } else if (this.activeSystem === 'trans') {
        res = await projectLivenessPage_trans(sendData);
      } else if (this.activeSystem === 'metag') {
        res = await projectLivenessPage_metag(sendData);
      } else if (this.activeSystem === 'metabo') {
        res = await projectLivenessPage_metabo(sendData);
      }
      if (res) {
        if (res.code === 200) {
          var pageData = res.data
          this.projectData = pageData.data
          this.projectPage.total = pageData.totalNum
          this.projectPage.pageSize = pageData.pageSize
          this.projectPage.currentNum = pageData.currentNum
          this.projectLivenessRatio = pageData.livenessRatio
          this.projectLoading = false
          this.loadingProject = false
        }else{
          this.projectLoading = false
          this.loadingProject = false
        }
      }else{
        this.projectLoading = false
        this.loadingProject = false
      }
    },

    async getCustomerData(type) {
      this.userLoading = true
      var sendData = {
        page: {
          current: this.customerPage.currentNum,
          size: this.customerPage.pageSize,
        }
      }
      if(type){
        sendData.page.current=1
        sendData.page.size=10
      }
      let length = this.customerSearchConditionTag.length
      if (length) {
        sendData.condition = {}
        this.customerSearchConditionTag.forEach(item => {
          let key = item.key
          if (key === 'createTime') {
            let value = item.value
            let index = value.indexOf('至')
            let value1 = value.substring(0, index)
            let value2 = value.substring(index + 1, value.length)
            sendData.condition.createTime = [addT(value1), addT(value2)]
          } else if (key === 'rawDataStatus') {
            sendData.condition.rawDataStatus = getRawDataStatusEnByCh(item.value)
          }  else {
            sendData.condition[key] = item.value
          }
        })
      } else {
        sendData.condition = {}
      }
      sendData.sorts = this.sortConditionTag
      let res
      if (this.activeSystem === 'bz') {
        res = await customerLivenessPage(sendData);
      } else if (this.activeSystem === 'trans') {
        res = await customerLivenessPage_trans(sendData);
      } else if (this.activeSystem === 'metag') {
        res = await customerLivenessPage_metag(sendData);
      } else if (this.activeSystem === 'metabo') {
        res = await customerLivenessPage_metabo(sendData);
      }
      if (res) {
        if (res.code === 200) {
          var pageData = res.data
          this.customerData = pageData.data
          this.customerPage.total = pageData.totalNum
          this.customerPage.pageSize = pageData.pageSize
          this.customerPage.currentNum = pageData.currentNum
          this.livenessRatio = pageData.livenessRatio
          this.userLoading = false
          this.loadingProject = false
        }else{
          this.userLoading = false
          this.loadingProject = false
        }
      }else{
        this.userLoading = false
        this.loadingProject = false
      } 
    },
    handleProjectPagePagination(page) {
      this.loading = true
      this.projectPage.currentNum = page.currentNum
      if (page.pageSize) {
        this.projectPage.pageSize = page.pageSize
      } else {
        this.projectPage.pageSize = this.projectPage.total
      }
      this.getProjectData()
    },
    handleCustomerPagePagination(page) {
      this.loading = true
      this.customerPage.currentNum = page.currentNum
      if (page.pageSize) {
        this.customerPage.pageSize = page.pageSize
      } else {
        this.customerPage.pageSize = this.customerPage.total
      }
      this.getCustomerData()
    },
    // 处理系统切换
    handleSystemChange(tab) {
      this.projectPage.currentNum = 1,
      this.projectPage.pageSize = 10,
      this.customerPage.currentNum = 1,
      this.customerPage.pageSize = 10,
      this.loadingProject = true
      this.activeSystem = tab.name
      this.getProjectData()
      this.getCustomerData()
    },

    //获取项目列表
    // async getData() {
    //   this.loadingProject = true
    //   this.personUuids = this.user.personUuids
    //   const sendData = {}

    //   // 根据当前系统选择对应的API
    //   const api = this.activeSystem === 'bz' ? customerProjectsBySalesName : customerProjectsBySalesName_trans
    //   const res = await api(sendData)

    //   if (res) {
    //     if (res.code === 200) {
    //       // 处理新的数据结构
    //       this.allSalesData = {}
    //       this.salesList = []

    //       // 遍历销售数据
    //       res.data.salesWithCustomersAndProjectList.forEach((salesData, index) => {
    //         const sales = salesData.sales
    //         this.salesList.push({
    //           name: sales.name,
    //           id: `sales-${index}` // 使用纯数字索引作为唯一标识
    //         })
    //         this.allSalesData[`sales-${index}`] = salesData.customersAndProjects
    //       })
    //       this.updateProjectData()
    //     }
    //   }
    // },

    // 分页方法
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.page.currentNum = val
      this.getData()
    },

    // 复制项目ID
    copyProjectId(projectId) {
      navigator.clipboard.writeText(projectId).then(() => {
        this.$message.success('项目ID已复制到剪贴板')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },

    // 跳转到项目详情
    goToProjectDetail(projectId) {
      let baseUrl
      if(this.activeSystem === 'bz'){
        baseUrl = '/bzWeb/desc'
      }else if(this.activeSystem === 'trans'){
        baseUrl = '/transWeb/desc'
      }else if(this.activeSystem === 'meta'){
        baseUrl = '/metagWeb_v3/desc'
      }else if(this.activeSystem === 'metabo'){
        baseUrl = '/metaboWeb/desc'
      }
      window.open(`${baseUrl}?projectId=${projectId}`)
    }
  }
}
</script>

<style scoped>
.system-condition {
  padding: 20px;
}

.system-tabs {
  margin-bottom: 20px;
}

.system-tabs :deep(.el-tabs__header) {
  margin-bottom: 20px;
}

.system-tabs :deep(.el-tabs__item) {
  font-size: 16px;
  padding: 0 20px;
}

.status-card,
.user-stats-card {
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.filter-container {
  float: right;
  display: flex;
  align-items: center;
}

.el-tag {
  margin-right: 5px;
  margin-bottom: 5px;
}

.project-id-container {
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 5px;
}

.project-id-container .el-button {
  padding: 0 5px;
  margin-left: 2px;
}
</style>
